import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import regexp from '@/common/regexp';
import { API_URL, IRelationshipTypeDto } from '@/dtos';
import { Relationship } from '@/modules/transaction/transaction.types';

export const useGetRelationshipListQuery = () => {
  const { data, isLoading } = useQuery([API_URL.ENUMS_RELATIONSHIP_TYPES], () =>
    api.get<IRelationshipTypeDto[]>(API_URL.ENUMS_RELATIONSHIP_TYPES)
  );

  const relationshipList: Relationship[] = (data?.data || []).map(
    (relation): Relationship => ({
      id: `${relation.id}`,
      name: (relation.name || '').replace(regexp.DASH_SYMBOL, ' '),
      value: relation.name || '',
    })
  );

  return {
    relationshipList,
    isLoading,
  };
};
